<div class="operations">
  @for (action of actions; track action.id) {
    @if (action.copy_step?.operation_step_type !== 'edit_selected_copy') {
      <app-menu-group-button
        [matTooltip]="action.$$toolTip"
        [matTooltipDisabled]="false"
        [disabled]="disabled"
        [readonly]="action.$$disabled || !action.read_access && readonly"
        (itemClick)="onActionClick($event)"
        [item]="action"
      ></app-menu-group-button>
    }
  }

  @if (artifact) {
    <button
      class="qr-code-button"
      mat-icon-button
      [attr.aria-label]="'TRANS__OPERATIONS_TOOLBAR__CREATE_QR_CODE' | translate"
      type="button"
      [matTooltip]="'TRANS__OPERATIONS_TOOLBAR__CREATE_QR_CODE' | translate"
      (click)="onGenerateQrCodeClick()"
    >
      <mat-icon>qr_code</mat-icon>
    </button>
  }
</div>
